import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import Layout from 'components/Layout';
import CategorySlider from 'components/CategorySlider';
import CouponSlider from 'components/CouponSlider';
import EcommerceFormat from 'components/EcommerceFormat';
import ProcessChange from 'components/ProcessChange';
import CartFactory from 'factories/Cart';
import CartService from 'services/Cart/service';
import CouponService from 'services/Coupon/service';
import { categories_links } from 'config';
import { handleize } from 'config/utils';
import { CartContext } from '../../cart/CartContext';
import { types } from '../../types/types';
import './style.scss';
import Loading from 'components/Loading';
import PopupStepsEcommerce from 'components/PopupStepsEcommerce';
import PopupLayout from "components/PopupLayout";
import ActionsWebFactory from 'factories/ActionsWeb';

const Categories = ({ match }) => {

    const { cartData, cartDispatch } = useContext(CartContext);
    const [currentCategory, setCurrentCategory] = useState({});
    const [privateCoupons, setPrivateCoupons] = React.useState([]);
    const [categoriesFormat, setCategoriesFormat] = useState([]);
    const [currentCategoryPath, setCurrentCategoryPath] = useState('');
    const customTemplate = 'ecommerce';
    const [stepChange,setStepChange] = useState(1);
    const [valueCopy,setValueCopy]=useState(false);
    const [showStepEcommerce, setShowStepEcommerce] = useState(false);

    // send click barcode for processchange
   const handleEcomerce=()=>{
        setValueCopy(true);

    }
    //show popup steps ecommerce
    const openStepsEcommerce= (event, forceValue = "none") => {
        event.preventDefault();
        setShowStepEcommerce(forceValue === "none" ? !showStepEcommerce : forceValue);
        ActionsWebFactory.setItemActionsWeb('categoryclick',false); //show popup ecomerce
        // disable with click
    };

    useEffect(() => {
        categories_links.map( item => {
            if(match.params.handle === item.handle){
                setCurrentCategoryPath(item.handle);
                setCurrentCategory(item);
                //show step ecommerce if path es ecommerce
                if(match.params.handle=="ecommerce" && ActionsWebFactory.getItemActionsWeb('categoryclick')==true){
                    setShowStepEcommerce(true);
                }
                ///-----
            }
        });

        Promise.all([CartService.getLastCart()]).then(couponList=>{
            if(couponList && ['200', '201'].includes(couponList[0].internalCode) ){
                localStorage.setItem("maxLimit", couponList[0].payload.maxItems);
                cartDispatch({
                    type: types.update,
                    payload: CartFactory.initLastCart(couponList[0].payload)
                });
            } else {
                cartDispatch({
                    type: types.update,
                    payload: CartFactory.reset()
                });
            }
        });
    }, []);


    useEffect(() => {
        if(currentCategoryPath===''){
            return;
        }

        Promise.all([CouponService.getListPrivate()]).then(couponList=>{
            if(couponList && couponList[0].coupons){
                const couponGroups = couponList[0].coupons;

                //categories format
                const categoriesFound = [];
                categories_links.map(category => {
                    let isFound = 0;
                    couponGroups.map( group => {
                        if(handleize(group.option.couponGroupName) === category.handle) isFound++;
                    });
                    if(isFound > 0) categoriesFound.push(category);
                });
                if(categoriesFound.length > 0) setCategoriesFormat(categoriesFound);

                //coupons format
                couponGroups.map( group => {
                    if(group.option.couponGroupName && handleize(group.option.couponGroupName) === currentCategoryPath){
                        setPrivateCoupons(group.coupons);
                        //execute temporizador
                        setTimeout(function(){
                            setStepChange(2);
                        },0)
                    }
                });
            }
        });
    }, [currentCategoryPath]);

    return (
        <div className="categoria is-logged">
            <Layout showBanner={false}>
                <CategorySlider currentPath={match.params.handle} categories={categoriesFormat}/>
                <section className="coupons-search mb-lg-4">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 pt-4 pb-4">
                                <form method="post" name="formSearch">
                                    <div className="row pl-2 pr-2">
                                        <div className="col-12 col-lg-4 d-none d-lg-flex justify-content-lg-start align-content-center">
                                            {cartData.state==='A' && cartData.items.length>0 ?
                                                <p className="text-left red m-0 my-auto">Tu cupones seleccionados, <br/>listos para canjear: {cartData.items.length}</p>
                                                :
                                                <p className="text-left red m-0 my-auto">Selecciona los cupones<br/>a canjear:</p>
                                            }
                                        </div>
                                        <div className="col-12 col-lg-4 d-flex justify-content-center align-content-center mb-2 mb-lg-0">
                                            <p className="text-center red m-0 my-auto">
                                                <strong className="red-dark category-title">{currentCategory.title}</strong>
                                            </p>
                                        </div>
                                        {/*
                                        <div className="col-12 col-lg-4 d-flex justify-content-center justify-content-lg-end align-content-center">
                                            <p className="text-center m-0 my-auto">
                                                <input type="text" name="textBoxSearch" placeholder="¿Qué producto buscas?"/></p>
                                        </div>
                                        */}
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="coupons">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                            {stepChange === 1 ?
                                <Loading type="wong--hover" />
                            :
                            <>
                            {privateCoupons.length > 0
                                    ? 
                                    (currentCategoryPath===customTemplate
                                        ?
                                        <EcommerceFormat coupons={privateCoupons} hasSession={true}
                                        handleEcomerceCategorieProcessChange={handleEcomerce} />
                                        :
                                        <CouponSlider coupons={privateCoupons} noslick={true} hasSession={true}/>
                                    )
                                    :
                                    <>
                                    <br /><br /><br /><br /><br />
                                    <p className="text-center">No se han encontrado cupones disponibles</p>
                                    <br /><br /><br />
                                    </>
                            }

                            </>
                            }
                            </div>
                        </div>
                    </div>
                </section>
            </Layout>
            <ProcessChange category={match.params.handle} valueCopy={valueCopy}/>
            <PopupLayout isShowwing={showStepEcommerce} showingCallback={openStepsEcommerce}>
                <PopupStepsEcommerce category={match.params.handle} ></PopupStepsEcommerce>
            </PopupLayout>

        </div>
    )
};

Categories.propTypes = {
    match: PropTypes.object
};
export default Categories;
